import React from 'react';
import Badge from 'shared/components/UC/Badge';
import { MatchConfidence } from '../../../types/bulkAssignment';

const LABEL: Record<MatchConfidence, string> = {
  high: 'Alta',
  medium: 'Media',
  low: 'Baja',
};

// Colour follows the kit's meaning: verde = está bien, azul = correcto pero
// intermedio, amarillo = requiere atención. Never colour alone — the level is
// always spelled out (WCAG 1.4.1).
const VARIANT: Record<MatchConfidence, 'success' | 'info' | 'warning'> = {
  high: 'success',
  medium: 'info',
  low: 'warning',
};

interface MatchConfidenceBadgeProps {
  level: MatchConfidence;
  /** Raw 0–1 value from the file, surfaced on hover. */
  value: number;
}

const MatchConfidenceBadge: React.FC<MatchConfidenceBadgeProps> = ({ level, value }) => (
  <span title={`Confianza del match: ${value.toFixed(2)} de 1,00`}>
    <Badge label={LABEL[level]} variant={VARIANT[level]} />
  </span>
);

export default MatchConfidenceBadge;
